// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AccreditationsRouteImport } from './routes/accreditations'
import { Route as AirSourceHeatPumpsRouteImport } from './routes/air-source-heat-pumps'
import { Route as BoilerUpgradeSchemeRouteImport } from './routes/boiler-upgrade-scheme'
import { Route as BoilersHeatingRouteImport } from './routes/boilers-heating'
import { Route as BookRouteImport } from './routes/book'
import { Route as CommercialRouteImport } from './routes/commercial'
import { Route as CommercialCaseStudiesRouteImport } from './routes/commercial-case-studies'
import { Route as CommercialComplianceRouteImport } from './routes/commercial-compliance'
import { Route as CommercialDampMouldVentilationRouteImport } from './routes/commercial-damp-mould-ventilation'
import { Route as CommercialHeatPumpsRouteImport } from './routes/commercial-heat-pumps'
import { Route as CommercialHeatingRouteImport } from './routes/commercial-heating'
import { Route as CommercialInsulationRouteImport } from './routes/commercial-insulation'
import { Route as CommercialRetrofitRouteImport } from './routes/commercial-retrofit'
import { Route as CommercialSocialValueRouteImport } from './routes/commercial-social-value'
import { Route as CommercialSolarPvRouteImport } from './routes/commercial-solar-pv'
import { Route as CommercialStructuralRouteImport } from './routes/commercial-structural'
import { Route as ComplaintsPolicyRouteImport } from './routes/complaints-policy'
import { Route as CompleteYourEstimateRouteImport } from './routes/complete-your-estimate'
import { Route as ConsumerDutyPolicyRouteImport } from './routes/consumer-duty-policy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ContentRouteImport } from './routes/content'
import { Route as CoverageRouteImport } from './routes/coverage'
import { Route as DampSurveyRouteImport } from './routes/damp-survey'
import { Route as DataProtectionRouteImport } from './routes/data-protection'
import { Route as DesignSolarRouteImport } from './routes/design-solar'
import { Route as FinanceCalculatorRouteImport } from './routes/finance-calculator'
import { Route as FinanceLoanCalculatorRouteImport } from './routes/finance-loan-calculator'
import { Route as FinancingRouteImport } from './routes/financing'
import { Route as FinancingI4fHowItWorksRouteImport } from './routes/financing-i4f-how-it-works'
import { Route as FinancingSolarLeasePlanRouteImport } from './routes/financing-solar-lease-plan'
import { Route as FinancingoptionsRouteImport } from './routes/financingoptions'
import { Route as ForTradeRouteImport } from './routes/for-trade'
import { Route as GrantsRouteImport } from './routes/grants'
import { Route as HeatingControlsRouteImport } from './routes/heating-controls'
import { Route as InternalWallInsulationRouteImport } from './routes/internal-wall-insulation'
import { Route as LoftInsulationRouteImport } from './routes/loft-insulation'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as RemedialWallTiesRouteImport } from './routes/remedial-wall-ties'
import { Route as ServicesRouteImport } from './routes/services'
import { Route as SolarRouteImport } from './routes/solar'
import { Route as SolarFollowUpRouteImport } from './routes/solar-follow-up'
import { Route as SolarGrantsWalesRouteImport } from './routes/solar-grants-wales'
import { Route as SolarPvRouteImport } from './routes/solar-pv'
import { Route as SolarSavingsCalculatorRouteImport } from './routes/solar-savings-calculator'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as TheHomeCheckGroupRouteImport } from './routes/the-home-check-group'
import { Route as TheTeamRouteImport } from './routes/the-team'
import { Route as UploadsRouteImport } from './routes/uploads'
import { Route as VentilationExtractionRouteImport } from './routes/ventilation-extraction'
import { Route as CommercialSectorsSlugRouteImport } from './routes/commercial-sectors.$slug'
import { Route as ContentIndexRouteImport } from './routes/content.index'
import { Route as ContentSlugRouteImport } from './routes/content.$slug'
import { Route as ContentUnlockRouteImport } from './routes/content.unlock'
import { Route as LpCavityInsulationRemovalRouteImport } from './routes/lp.cavity-insulation-removal'
import { Route as LpCavityWallInsulationRouteImport } from './routes/lp.cavity-wall-insulation'
import { Route as PropertiesIndexRouteImport } from './routes/properties.index'
import { Route as PropertiesReferenceCodeRouteImport } from './routes/properties.$referenceCode'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as ServicesSlugRouteImport } from './routes/services.$slug'
import { Route as UploadsJourneysRouteImport } from './routes/uploads.journeys'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AccreditationsRoute = AccreditationsRouteImport.update({
            id: '/accreditations',path: '/accreditations',getParentRoute: () => rootRouteImport
          })
const AirSourceHeatPumpsRoute = AirSourceHeatPumpsRouteImport.update({
            id: '/air-source-heat-pumps',path: '/air-source-heat-pumps',getParentRoute: () => rootRouteImport
          })
const BoilerUpgradeSchemeRoute = BoilerUpgradeSchemeRouteImport.update({
            id: '/boiler-upgrade-scheme',path: '/boiler-upgrade-scheme',getParentRoute: () => rootRouteImport
          })
const BoilersHeatingRoute = BoilersHeatingRouteImport.update({
            id: '/boilers-heating',path: '/boilers-heating',getParentRoute: () => rootRouteImport
          })
const BookRoute = BookRouteImport.update({
            id: '/book',path: '/book',getParentRoute: () => rootRouteImport
          })
const CommercialRoute = CommercialRouteImport.update({
            id: '/commercial',path: '/commercial',getParentRoute: () => rootRouteImport
          })
const CommercialCaseStudiesRoute = CommercialCaseStudiesRouteImport.update({
            id: '/commercial-case-studies',path: '/commercial-case-studies',getParentRoute: () => rootRouteImport
          })
const CommercialComplianceRoute = CommercialComplianceRouteImport.update({
            id: '/commercial-compliance',path: '/commercial-compliance',getParentRoute: () => rootRouteImport
          })
const CommercialDampMouldVentilationRoute = CommercialDampMouldVentilationRouteImport.update({
            id: '/commercial-damp-mould-ventilation',path: '/commercial-damp-mould-ventilation',getParentRoute: () => rootRouteImport
          })
const CommercialHeatPumpsRoute = CommercialHeatPumpsRouteImport.update({
            id: '/commercial-heat-pumps',path: '/commercial-heat-pumps',getParentRoute: () => rootRouteImport
          })
const CommercialHeatingRoute = CommercialHeatingRouteImport.update({
            id: '/commercial-heating',path: '/commercial-heating',getParentRoute: () => rootRouteImport
          })
const CommercialInsulationRoute = CommercialInsulationRouteImport.update({
            id: '/commercial-insulation',path: '/commercial-insulation',getParentRoute: () => rootRouteImport
          })
const CommercialRetrofitRoute = CommercialRetrofitRouteImport.update({
            id: '/commercial-retrofit',path: '/commercial-retrofit',getParentRoute: () => rootRouteImport
          })
const CommercialSocialValueRoute = CommercialSocialValueRouteImport.update({
            id: '/commercial-social-value',path: '/commercial-social-value',getParentRoute: () => rootRouteImport
          })
const CommercialSolarPvRoute = CommercialSolarPvRouteImport.update({
            id: '/commercial-solar-pv',path: '/commercial-solar-pv',getParentRoute: () => rootRouteImport
          })
const CommercialStructuralRoute = CommercialStructuralRouteImport.update({
            id: '/commercial-structural',path: '/commercial-structural',getParentRoute: () => rootRouteImport
          })
const ComplaintsPolicyRoute = ComplaintsPolicyRouteImport.update({
            id: '/complaints-policy',path: '/complaints-policy',getParentRoute: () => rootRouteImport
          })
const CompleteYourEstimateRoute = CompleteYourEstimateRouteImport.update({
            id: '/complete-your-estimate',path: '/complete-your-estimate',getParentRoute: () => rootRouteImport
          })
const ConsumerDutyPolicyRoute = ConsumerDutyPolicyRouteImport.update({
            id: '/consumer-duty-policy',path: '/consumer-duty-policy',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ContentRoute = ContentRouteImport.update({
            id: '/content',path: '/content',getParentRoute: () => rootRouteImport
          })
const CoverageRoute = CoverageRouteImport.update({
            id: '/coverage',path: '/coverage',getParentRoute: () => rootRouteImport
          })
const DampSurveyRoute = DampSurveyRouteImport.update({
            id: '/damp-survey',path: '/damp-survey',getParentRoute: () => rootRouteImport
          })
const DataProtectionRoute = DataProtectionRouteImport.update({
            id: '/data-protection',path: '/data-protection',getParentRoute: () => rootRouteImport
          })
const DesignSolarRoute = DesignSolarRouteImport.update({
            id: '/design-solar',path: '/design-solar',getParentRoute: () => rootRouteImport
          })
const FinanceCalculatorRoute = FinanceCalculatorRouteImport.update({
            id: '/finance-calculator',path: '/finance-calculator',getParentRoute: () => rootRouteImport
          })
const FinanceLoanCalculatorRoute = FinanceLoanCalculatorRouteImport.update({
            id: '/finance-loan-calculator',path: '/finance-loan-calculator',getParentRoute: () => rootRouteImport
          })
const FinancingRoute = FinancingRouteImport.update({
            id: '/financing',path: '/financing',getParentRoute: () => rootRouteImport
          })
const FinancingI4fHowItWorksRoute = FinancingI4fHowItWorksRouteImport.update({
            id: '/financing-i4f-how-it-works',path: '/financing-i4f-how-it-works',getParentRoute: () => rootRouteImport
          })
const FinancingSolarLeasePlanRoute = FinancingSolarLeasePlanRouteImport.update({
            id: '/financing-solar-lease-plan',path: '/financing-solar-lease-plan',getParentRoute: () => rootRouteImport
          })
const FinancingoptionsRoute = FinancingoptionsRouteImport.update({
            id: '/financingoptions',path: '/financingoptions',getParentRoute: () => rootRouteImport
          })
const ForTradeRoute = ForTradeRouteImport.update({
            id: '/for-trade',path: '/for-trade',getParentRoute: () => rootRouteImport
          })
const GrantsRoute = GrantsRouteImport.update({
            id: '/grants',path: '/grants',getParentRoute: () => rootRouteImport
          })
const HeatingControlsRoute = HeatingControlsRouteImport.update({
            id: '/heating-controls',path: '/heating-controls',getParentRoute: () => rootRouteImport
          })
const InternalWallInsulationRoute = InternalWallInsulationRouteImport.update({
            id: '/internal-wall-insulation',path: '/internal-wall-insulation',getParentRoute: () => rootRouteImport
          })
const LoftInsulationRoute = LoftInsulationRouteImport.update({
            id: '/loft-insulation',path: '/loft-insulation',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const RemedialWallTiesRoute = RemedialWallTiesRouteImport.update({
            id: '/remedial-wall-ties',path: '/remedial-wall-ties',getParentRoute: () => rootRouteImport
          })
const ServicesRoute = ServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => rootRouteImport
          })
const SolarRoute = SolarRouteImport.update({
            id: '/solar',path: '/solar',getParentRoute: () => rootRouteImport
          })
const SolarFollowUpRoute = SolarFollowUpRouteImport.update({
            id: '/solar-follow-up',path: '/solar-follow-up',getParentRoute: () => rootRouteImport
          })
const SolarGrantsWalesRoute = SolarGrantsWalesRouteImport.update({
            id: '/solar-grants-wales',path: '/solar-grants-wales',getParentRoute: () => rootRouteImport
          })
const SolarPvRoute = SolarPvRouteImport.update({
            id: '/solar-pv',path: '/solar-pv',getParentRoute: () => rootRouteImport
          })
const SolarSavingsCalculatorRoute = SolarSavingsCalculatorRouteImport.update({
            id: '/solar-savings-calculator',path: '/solar-savings-calculator',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const TheHomeCheckGroupRoute = TheHomeCheckGroupRouteImport.update({
            id: '/the-home-check-group',path: '/the-home-check-group',getParentRoute: () => rootRouteImport
          })
const TheTeamRoute = TheTeamRouteImport.update({
            id: '/the-team',path: '/the-team',getParentRoute: () => rootRouteImport
          })
const UploadsRoute = UploadsRouteImport.update({
            id: '/uploads',path: '/uploads',getParentRoute: () => rootRouteImport
          })
const VentilationExtractionRoute = VentilationExtractionRouteImport.update({
            id: '/ventilation-extraction',path: '/ventilation-extraction',getParentRoute: () => rootRouteImport
          })
const CommercialSectorsSlugRoute = CommercialSectorsSlugRouteImport.update({
            id: '/commercial-sectors/$slug',path: '/commercial-sectors/$slug',getParentRoute: () => rootRouteImport
          })
const ContentIndexRoute = ContentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ContentRoute
          })
const ContentSlugRoute = ContentSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ContentRoute
          })
const ContentUnlockRoute = ContentUnlockRouteImport.update({
            id: '/unlock',path: '/unlock',getParentRoute: () => ContentRoute
          })
const LpCavityInsulationRemovalRoute = LpCavityInsulationRemovalRouteImport.update({
            id: '/lp/cavity-insulation-removal',path: '/lp/cavity-insulation-removal',getParentRoute: () => rootRouteImport
          })
const LpCavityWallInsulationRoute = LpCavityWallInsulationRouteImport.update({
            id: '/lp/cavity-wall-insulation',path: '/lp/cavity-wall-insulation',getParentRoute: () => rootRouteImport
          })
const PropertiesIndexRoute = PropertiesIndexRouteImport.update({
            id: '/properties/',path: '/properties/',getParentRoute: () => rootRouteImport
          })
const PropertiesReferenceCodeRoute = PropertiesReferenceCodeRouteImport.update({
            id: '/properties/$referenceCode',path: '/properties/$referenceCode',getParentRoute: () => rootRouteImport
          })
const STokenRoute = STokenRouteImport.update({
            id: '/s/$token',path: '/s/$token',getParentRoute: () => rootRouteImport
          })
const ServicesSlugRoute = ServicesSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => ServicesRoute
          })
const UploadsJourneysRoute = UploadsJourneysRouteImport.update({
            id: '/journeys',path: '/journeys',getParentRoute: () => UploadsRoute
          })





const ContentRouteChildren = {
  ContentSlugRoute: ContentSlugRoute,ContentUnlockRoute: ContentUnlockRoute,ContentIndexRoute: ContentIndexRoute
}

const ContentRouteWithChildren = ContentRoute._addFileChildren(ContentRouteChildren)




const ServicesRouteChildren = {
  ServicesSlugRoute: ServicesSlugRoute
}

const ServicesRouteWithChildren = ServicesRoute._addFileChildren(ServicesRouteChildren)




const UploadsRouteChildren = {
  UploadsJourneysRoute: UploadsJourneysRoute
}

const UploadsRouteWithChildren = UploadsRoute._addFileChildren(UploadsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,AccreditationsRoute: AccreditationsRoute,AirSourceHeatPumpsRoute: AirSourceHeatPumpsRoute,BoilerUpgradeSchemeRoute: BoilerUpgradeSchemeRoute,BoilersHeatingRoute: BoilersHeatingRoute,BookRoute: BookRoute,CommercialRoute: CommercialRoute,CommercialCaseStudiesRoute: CommercialCaseStudiesRoute,CommercialComplianceRoute: CommercialComplianceRoute,CommercialDampMouldVentilationRoute: CommercialDampMouldVentilationRoute,CommercialHeatPumpsRoute: CommercialHeatPumpsRoute,CommercialHeatingRoute: CommercialHeatingRoute,CommercialInsulationRoute: CommercialInsulationRoute,CommercialRetrofitRoute: CommercialRetrofitRoute,CommercialSocialValueRoute: CommercialSocialValueRoute,CommercialSolarPvRoute: CommercialSolarPvRoute,CommercialStructuralRoute: CommercialStructuralRoute,ComplaintsPolicyRoute: ComplaintsPolicyRoute,CompleteYourEstimateRoute: CompleteYourEstimateRoute,ConsumerDutyPolicyRoute: ConsumerDutyPolicyRoute,ContactRoute: ContactRoute,ContentRoute: ContentRouteWithChildren,CoverageRoute: CoverageRoute,DampSurveyRoute: DampSurveyRoute,DataProtectionRoute: DataProtectionRoute,DesignSolarRoute: DesignSolarRoute,FinanceCalculatorRoute: FinanceCalculatorRoute,FinanceLoanCalculatorRoute: FinanceLoanCalculatorRoute,FinancingRoute: FinancingRoute,FinancingI4fHowItWorksRoute: FinancingI4fHowItWorksRoute,FinancingSolarLeasePlanRoute: FinancingSolarLeasePlanRoute,FinancingoptionsRoute: FinancingoptionsRoute,ForTradeRoute: ForTradeRoute,GrantsRoute: GrantsRoute,HeatingControlsRoute: HeatingControlsRoute,InternalWallInsulationRoute: InternalWallInsulationRoute,LoftInsulationRoute: LoftInsulationRoute,PrivacyRoute: PrivacyRoute,RemedialWallTiesRoute: RemedialWallTiesRoute,ServicesRoute: ServicesRouteWithChildren,SolarRoute: SolarRoute,SolarFollowUpRoute: SolarFollowUpRoute,SolarGrantsWalesRoute: SolarGrantsWalesRoute,SolarPvRoute: SolarPvRoute,SolarSavingsCalculatorRoute: SolarSavingsCalculatorRoute,ThankYouRoute: ThankYouRoute,TheHomeCheckGroupRoute: TheHomeCheckGroupRoute,TheTeamRoute: TheTeamRoute,UploadsRoute: UploadsRouteWithChildren,VentilationExtractionRoute: VentilationExtractionRoute,CommercialSectorsSlugRoute: CommercialSectorsSlugRoute,LpCavityInsulationRemovalRoute: LpCavityInsulationRemovalRoute,LpCavityWallInsulationRoute: LpCavityWallInsulationRoute,PropertiesReferenceCodeRoute: PropertiesReferenceCodeRoute,STokenRoute: STokenRoute,PropertiesIndexRoute: PropertiesIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)